module.exports = __webpack_public_path__ + "static/media/advantage_img_3.eaf33b2e.png";